<div class="flex-grow-1">
  <div class="row flex-grow-1">
      <div appSetHeight class="col-12 pl-0 pr-0 flex-grow-1">
        <div class="h-100 overflow-auto">
            <div class="col-12 summary pl-0">
                <div id="report">
                    <div id="roros" *ngIf="data">
                        <button (click)="exportData()" id="export" class="btn btn-white btn-sm">
                            Export Data
                            <span class="svg-icon svg-icon-xs ms-1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
                            </span>
                        </button>
                        <table class='table table-striped' aria-labelledby="tableLabel">
                            <thead>
                            <tr>
                                <th class="description">
                                    NAME
                                </th>
                                <th class="description">
                                    DEPOT NAME
                                </th>
                                <th class="count">
                                    ALL CONTAINERS
                                </th>
                                <th class="count">
                                    SKIPS
                                </th>
                                <th class="count">
                                    ROROS
                                </th>
                                <th class="count">
                                    ALL VEHICLES
                                </th>
                                <th class="count">
                                    SKIP VEHICLES
                                </th>
                                <th class="count">
                                    RORO VEHICLES
                                </th>
                                <th class="count">
                                    MOBILE SCANNER
                                </th>
                                <th class="long-count">
                                    CHECK - SHOULD BE 0
                                </th>
                            </tr>
                            </thead>
                            <tbody class="dummy">
                            <tr>
                                <td class="h-2" colspan="12"></td>
                            </tr>
                            </tbody>
                            <tbody>
                                <ng-container *ngFor="let record of data.billingSummaryRecords">
                                    <tr>
                                        <td class="description" title="{{ record.name }}">
                                            {{ record.name }}
                                        </td>
                                        <td class="description" title="{{ record.depotName }}">
                                            {{ record.depotName }}
                                        </td>
                                        <td class="count">
                                            {{ record.allContainers }}
                                        </td>
                                        <td class="count">
                                            {{ record.skips }}
                                        </td>
                                        <td class="count">
                                            {{ record.roRos }}
                                        </td>
                                        <td class="count">
                                            {{ record.allVehicles }}
                                        </td>
                                        <td class="count">
                                            {{ record.skipVehicles }}
                                        </td>
                                        <td class="count">
                                            {{ record.roRoVehicles }}
                                        </td>
                                        <td class="count">
                                            {{ record.mobileScanner }}
                                        </td>
                                        <td class="count">
                                            {{ record.checkShouldBe0 }}
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>